export const DELETE_PHOTO = 'DELETE_PHOTO';
export const FETCH_PHOTOS = 'FETCH_PHOTOS';
export const UPDATE_MAIN_PHOTO = 'UPDATE_MAIN_PHOTO';
export const ROTATE_PHOTO = 'ROTATE_PHOTO';
export const HAS_FINISHED_PHOTOS_UPLOAD = 'HAS_FINISHED_PHOTOS_UPLOAD';
export const HAS_STARTED_PHOTOS_UPLOAD = 'HAS_STARTED_PHOTOS_UPLOAD';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const UPDATE_PHOTOS = 'UPDATE_PHOTOS';
export const UPDATE_LIST_PHOTOS = 'UPDATE_LIST_PHOTOS';
export const UPDATE_DESCRIPTION_ON_PHOTO_LIST = 'UPDATE_DESCRIPTION_ON_PHOTO_LIST';
export const CHANGE_DROPZONE_VISIBILITY = 'CHANGE_DROPZONE_VISIBILITY';
export const UPDATE_HAS_SNACK_BAR = 'UPDATE_HAS_SNACK_BAR';
export const ADD_PHOTOS_TO_UPLOAD = 'ADD_PHOTOS_TO_UPLOAD';
export const FETCH_ROOM_SUGGESTIONS = 'FETCH_ROOM_SUGGESTIONS';
